
import { useEffect, RefObject } from 'react';

interface UseIntersectionObserverProps {
  ref: RefObject<HTMLElement>;
  threshold?: number;
  rootMargin?: string;
}

export const useIntersectionObserver = ({
  ref,
  threshold = 0.1,
  rootMargin = '0px',
}: UseIntersectionObserverProps) => {
  useEffect(() => {
    if (!ref.current) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold, rootMargin }
    );
    
    const elements = ref.current.querySelectorAll('.reveal');
    elements.forEach(el => observer.observe(el));
    
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, [ref, threshold, rootMargin]);
};
